<template>
	<div class="t-page_contacts t-work-area">
		<h1>{{ pageText.title }}</h1>
		<div class="t-work-area__row">
			<div class="t-work-area__column_big">
				<div class="t-work-area__cell">
					<div class="t-contactsItem" v-for="(item, index) in contacts" :key="index">
						<h2>{{ item.title }}</h2>
						<div class="t-contactsItem__time">{{ item.time }}</div>
						<ul class="t-contactsItem__contacts">
							<li v-for="(contact, index_contact) in item.contacts">
								<b>{{ contact.title }}</b>
								{{ contact.value }}
							</li>
						</ul>
						<div class="t-contactsItem__address t-default" v-if="item.address" v-html="item.address">
						</div>

						<template v-if="typeof item.coordinates !== 'string'">
							<yandex-map
									:coords="item.coordinates"
									zoom="14"
									style="width: 100%; height: 200px;"
									:controls=[]
									:suppressMapOpenBlock=true
							>
								<ymap-marker
										:marker-id="index"
										marker-type="placemark"
										:coords="item.coordinates"
										:balloon="{header: item.title, body: item.address}"
								></ymap-marker>
							</yandex-map>
						</template>
					</div>
				</div>
				<div class="t-work-area__cell t-requisites">
					<h2>{{ pageText.title_2 }}</h2>
					<div v-html="requisites" class="t-default"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/contactsPage.json' : 'staticText',
        main: {
            title: "Контакты",
						title_2: "Реквизиты"
        }
    };

    import {store} from '../../store'

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

		export default {
		    data(){
		        return {
                pageText: {}
						}
				},
        methods: {
            ...mapActions(['UpdatePreloadState']),
            Load(pageText){
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
								}, 500)
            }
        },
		    computed: {
						...mapGetters('contacts', ['requisites', 'contacts'])
				},
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
				beforeRouteEnter (to, from, next) {
            let count = 0;

            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });

            store.dispatch('contacts/LoadContacts').then(() => {count++;RunNext();});

            let RunNext = () => {
                if(count > 1)
                    next(vm => vm.Load(pageText))
            }
				}
		}
</script>

<style lang="sass">
.t-contactsItem
	width: 100%
	margin: 0 0 32px
	&:last-child
		margin-bottom: 0
	h2
		color: $blue
		margin-bottom: 18px
		font-size: 22px
	&__time
		margin-bottom: 16px
	&__contacts
		display: flex
		align-items: flex-start
		margin: 0 0 16px
		list-style-type: none
		flex-wrap: wrap
		li
			margin-right: 32px
		b
			display: block
			margin-bottom: 8px
			line-height: 1.2
	&__address
		margin: 0 0 16px

.t-requisites
	h2
		color: $blue
		margin-bottom: 18px
		font-size: 22px

.ymaps-2-1-73-map-copyrights-promo, .ymaps-2-1-73-copyright
	display: none !important
</style>


// WEBPACK FOOTER //
// src/vue_pages/Contacts/Index.vue